import React, { useEffect, useRef, useState } from "react";
import { cityProvinces } from "../data/DataCityProvinces";
import { CommodityName } from "../data/DataTypes";
import { fetchNearestStore } from "../utils/gateway";

const MapsLocator = ({ options, onMount, className }) => {
  const divProps = { ref: useRef(), className };
  const [currentPosition, setCurrentPosition] = useState(null);
  const [provincesList, setProvincesList] = useState([]);
  const [selectProvinces, setSelectProvinces] = useState(null);
  const [cityList, setCityList] = useState([]);
  const [selectCity, setSelectCity] = useState(null);
  const [inputKeyword, setInputKeyword] = useState("");
  const [selectCommodity, setSelectCommodity] = useState("");
  const [params, setParams] = useState(null);

  const getListProvinces = () => {
    let list = [];

    cityProvinces.forEach((data) => {
      list.push(data.provinces);
    });

    const newList = [...new Set(list.sort())];
    setProvincesList(newList);
  };

  const getListCity = () => {
    let newCity = [];

    cityProvinces.forEach((data) => {
      if (data.provinces === selectProvinces) {
        newCity.push(data);
      }
    });

    setCityList(newCity);
  };

  useEffect(() => {
    getListProvinces();
  }, []);

  useEffect(() => {
    getListCity();
  }, [selectProvinces]);

  useEffect(() => {
    const onLoad = () => {
      const handleLocationError = (browserHasGeolocation, infoWindow, pos) => {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
          browserHasGeolocation
            ? "Error: The Geolocation service failed."
            : "Error: Your browser doesn't support geolocation."
        );
        infoWindow.open(map);
      };

      const map = new window.google.maps.Map(divProps.ref.current, options);
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          setCurrentPosition({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            city: ""
          });

          const initParams = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            city: "",
            keyword: "",
            commodity: ""
          };
          setParams(initParams);
        });
      } else {
        // Browser doesn't support Geolocation
        handleLocationError(false, infowindow, map.getCenter());
      }
    };

    if (!window.google) {
      const script = document.createElement(`script`);
      script.type = `text/javascript`;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.API_KEY_MAPS}&libraries=places&signature=-ilnwXFPN5UzQjNRqpJhkAxHQRg=`;
      const headScript = document.getElementsByTagName(`script`)[0];
      headScript.parentNode.insertBefore(script, headScript);
      script.addEventListener(`load`, onLoad);
      return () => script.removeEventListener(`load`, onLoad);
    } else onLoad();
  }, [divProps.ref, onMount]);

  useEffect(() => {
    const onLoad = async () => {
      const map = new window.google.maps.Map(
        divProps.ref.current,
        currentPosition
      );
      const infoWin = new google.maps.InfoWindow();
      const bounds = new google.maps.LatLngBounds();
      if (params != null) {
        const getLocation = new window.google.maps.Marker({
          map,
          position: { lat: params.lat, lng: params.lng },
          title: "Lokasi kamu",
          animation: google.maps.Animation.DROP,
          icon: {
            url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png"
          }
        });

        getLocation.addListener("load", () => {
          infoWin.open(map, getLocation);
        });
        try {
          const resNearestStore = await fetchNearestStore(params);
          const markers = await resNearestStore.map((location, i) => {
            const marker = new google.maps.Marker({
              position: {
                lat: location.latitude,
                lng: location.longitude
              }
            });

            const markerInfo = `
          <div id="content">
          <div id="siteNotice"></div>
          <h3 id="firstHeading" class="firstHeading">${location.store_name}</h3>
          <div id="bodyContent">
          <p><b>${location.store_name}</b>, ${location.full_address}</p>
          </div>
          </div>
          `;

            google.maps.event.addListener(marker, "click", (evt) => {
              infoWin.setContent(markerInfo);
              infoWin.setOptions({ maxWidth: 200 });
              infoWin.open(map, marker);
            });

            google.maps.event.addListener(marker, "mouseover", (evt) => {
              infoWin.setContent(location.store_name);
              infoWin.open(map, marker);
            });

            google.maps.event.addListener(marker, "mouseout", (evt) => {
              infoWin.close();
            });
            bounds.extend({
              lat: location.latitude,
              lng: location.longitude
            });
            return marker;
          });
          map.setCenter({ lat: params.lat, lng: params.lng });
          map.fitBounds(bounds);

          // Add a marker clusterer to manage the markers.
          new MarkerClusterer(map, markers, {
            imagePath:
              "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m"
          });
        } catch (error) {
          console.log(error);
        }
      }
    };
    if (window.google) {
      onLoad();
    }
  }, [divProps.ref, onMount, params]);

  const onSubmitMaps = (e) => {
    e.preventDefault();
    const latLngCity = selectCity == null ? currentPosition : selectCity;
    setParams({
      ...latLngCity,
      keyword: inputKeyword,
      commodity: selectCommodity
    });
  };

  const onSelectProvinces = (e) => {
    setSelectProvinces(e.target.value);
  };

  const onSelectCity = (e) => {
    setSelectCity(JSON.parse(e.target.value));
  };

  const inputkeywordMaps = (e) => {
    const re = /^[a-zA-Z0-9\.-\s]*$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setInputKeyword(e.target.value);
    }
  };

  const onSelectCommodity = (e) => {
    setSelectCommodity(e.target.value);
  };

  return (
    <div className="maps-wrapper">
      <div className="maps-container" {...divProps}></div>
      <div className="maps-input-container">
        <form onSubmit={onSubmitMaps}>
          <label>Provinsi</label>
          <select onChange={onSelectProvinces} defaultValue={currentPosition}>
            <option value={JSON.stringify(currentPosition)}>
              Provinsi anda
            </option>
            {provincesList &&
              provincesList.map((index, key) => (
                <option value={index} key={key}>
                  {index}
                </option>
              ))}
          </select>
          <label>Kota</label>
          <select onChange={onSelectCity} defaultValue={currentPosition}>
            <option value={JSON.stringify(currentPosition)}>Kota anda</option>
            {cityList &&
              cityList.map((index, key) => (
                <option
                  value={JSON.stringify({
                    lat: index.lat,
                    lng: index.lng,
                    city: index.name,
                    provinces: index.provinces
                  })}
                  key={key}
                >
                  {index.name}
                </option>
              ))}
          </select>
          <label>Nama Gedung/Jalan/Area</label>
          <input
            name="keyword"
            type="text"
            value={inputKeyword}
            placeholder="Gedung/Jalan/Area"
            onChange={inputkeywordMaps}
          />
          <label>Produk</label>
          <select
            type="text"
            placeholder="Produk"
            onChange={onSelectCommodity}
            value={selectCommodity}
          >
            <option defaultValue="" value="">
              Semua Produk
            </option>
            {CommodityName.map((index, key) => (
              <option value={index.key} key={key}>
                {index.name}
              </option>
            ))}
          </select>
          <button type="submit">Cari</button>
        </form>
      </div>
      <style jsx>{`
        .maps-wrapper {
          display: grid;
          width: 100%;
          height: 600px;
          grid-template-columns: 2fr 1fr;
          grid-column-gap: 20px;
        }

        .maps-container {
          width: 100%;
          height: 100%;
        }

        form {
          display: flex;
          flex-direction: column;
        }

        label {
          font-weight: bold;
          margin-bottom: 8px;
        }

        input,
        select {
          -webkit-appearance: none;

          border-radius: 8px;
          box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.4);
          height: 43px;
          padding: 0 16px;
          border: none;
          margin-bottom: 24px;
        }

        button {
          background-color: var(--color-red);
          font-weight: bold;
          border: none;
          color: white;
          padding: 16px 24px;
          border-radius: 8px;
          margin: 16px 0;
          box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.4);
        }
        button:hover {
          cursor: pointer;
        }

        @media only screen and (max-width: 600px) {
          .maps-wrapper {
            display: grid;
            width: 100%;
            height: 100%;
            grid-template-columns: 1fr;
            grid-column-gap: 0;
          }
          .maps-container {
            height: 420px;
          }
          input {
            margin-bottom: 12px;
          }
        }
      `}</style>
    </div>
  );
};

MapsLocator.defaultProps = {
  options: {
    center: { lat: -6.117664, lng: 106.906349 },
    zoom: 12
  }
};

export default MapsLocator;
